import { useEffect, useState } from "react";
import { constant, decryptData } from "../../utils/utils";
import useSelector from "../../store/selector";
import { Container } from "@mui/system";
import Header from "../common/Header";
import styles from "../../Style/Modules/aadharDetail.module.css";
import "../../Style/Theme/index.css";

import {
  Avatar,
  Box,
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import SubmitButton from "../common/SubmitButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Navigate, useLocation, useNavigate } from "react-router";

const AadharDetail = () => {
  let location = useLocation();
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [aadharDetailsFromRecoil, setAadharDetailsFromRecoil] = useState("");
  const navigate = useNavigate();
  const checkRecoilAadharData = async () => {
    let getPreAadharDatafromRecoil = getRecoilVal(
      constant.atomsName.AADHAR_DETAILS
    );

    let decryptedAadhardata = await decryptData(
      getPreAadharDatafromRecoil[location?.state?.AppId]
    );

    setAadharDetailsFromRecoil(JSON.parse(decryptedAadhardata));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(-1);
  };
  useEffect(() => {
    checkRecoilAadharData();
  }, []);

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Box
          component="form"
          noValidate
          id="aadharDetails"
          onSubmit={handleSubmit}
          //   onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Header showBar={true} step={2} />
          <Box component="aadharDetails" className={styles.aadharDetailBox}>
            <Box className={styles.aadharDetailBox1}>
              <Stack direction="row" spacing={2}>
                <Avatar
                  alt="UserPhoto"
                  src={`data:image/png;base64,${aadharDetailsFromRecoil?.kycdetails?.pht}`}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "4px solid #50E0FF",
                  }}
                />
              </Stack>
              <Typography className={styles.aadharDetailTypo}>
                {aadharDetailsFromRecoil?.kycdetails?.name}
              </Typography>
            </Box>
            <Box className={styles.aadharDetailBox2}>
              <Divider className="dividerbg_Th">
                {/* <Divider> */}
                <Chip
                  className={`${styles.aadharDetailPaper}`}
                  icon={<AccountCircleIcon />}
                  sx={{ fontWeight: "bold" }}
                  label="AADHAAR DETAILS"
                />
              </Divider>
              <Paper className={styles.aadharDetailPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Father Name</Typography>
                <Typography>
                  {aadharDetailsFromRecoil?.kycdetails?.fname}
                </Typography>
              </Paper>
              <Paper className={styles.aadharDetailPaper}>
                <Typography sx={{ fontWeight: "bold" }}>UID</Typography>
                <Typography>
                  {aadharDetailsFromRecoil?.kycdetails?.uid}
                </Typography>
              </Paper>
              <Paper className={styles.aadharDetailPaper}>
                <Typography sx={{ fontWeight: "bold" }}>DOB</Typography>
                <Typography>
                  {aadharDetailsFromRecoil?.kycdetails?.dob}
                </Typography>
              </Paper>
              <Paper className={styles.aadharDetailPaper}>
                <Typography sx={{ fontWeight: "bold" }}>Gender</Typography>
                <Typography>
                  {/* {aadharDetailsFromRecoil?.kycdetails?.gender} */}
                  {aadharDetailsFromRecoil?.kycdetails?.gender &&
                  aadharDetailsFromRecoil?.kycdetails?.gender === "M"
                    ? "Male"
                    : aadharDetailsFromRecoil?.kycdetails?.gender === "F"
                    ? "Female"
                    : aadharDetailsFromRecoil?.kycdetails?.gender === "O"
                    ? "Other"
                    : aadharDetailsFromRecoil?.kycdetails?.gender}
                </Typography>
              </Paper>
              <Paper className={styles.aadharDetailPaper1}>
                <Typography sx={{ fontWeight: "bold" }}>Address</Typography>
                <Typography sx={{ wordWrap: "break-word" }}>
                  {aadharDetailsFromRecoil?.kycdetails?.address}
                </Typography>
              </Paper>
            </Box>
          </Box>
          <SubmitButton displayVal="Close" hasNote="No" />
        </Box>
        {/* {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )} */}
      </Container>
    </>
  );
};

export default AadharDetail;
